import React, { Component } from "react";
import {
  Grid,
  Icon,
  Button,
  Divider,
  Dropdown,
  Label
} from "semantic-ui-react";
import "../customerinfo/custinfo.css";
import EmployeeForm from "../shared-components/employeeform";
import { genempdrop } from "./../../services/gendropdown";

class EmployeeInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      listitems: [],
      list: [],
      editing: false,
      editvalue: {},
      deletevalue: [],
      deletelist: [],
      editinfo: {},
      newcontact: false,
      jobtrackerlist: []
    };
  }

  genreportsto() {
    if (this.state.editvalue.reportsto) {

      console.log(this.state.jobtrackerlist);
      let value = this.state.jobtrackerlist.find(
        jt => jt.key === this.state.editvalue.reportsto
      );
      return value;
    } else {
      return null;
    }
  }

  handlesave(emp) {
    if (this.state.newcontact) {
      this.props.addemployee(emp);
    } else {
      this.props
        .updateemployee(emp)
        .then(emp => this.setState({ editvalue: emp }));
    }
  }
  handledelete() {
    this.state.deletevalue.map(dl => this.props.handleDelete(dl));
    this.setState({ deletevalue: [] });
  }
  geneditform() {
    let employee = Object.assign({}, this.state.editvalue);
    employee.payrollcomments = employee.payrollcomments || "";
    var formtitle = "Edit:";
    let reportsTo = this.genreportsto();
    if (this.state.newcontact === true) {
      formtitle = "Add Contact";
    }
    if (this.state.editing) {
      console.log("jtadmin list", genempdrop(this.props.employees.filter(e => e.jtadmin)))
      return (
        <div>
          <EmployeeForm
            update={(param, value) => {
              let newedit = this.state.editvalue;
              (newedit[param] = value), this.setState({ editvalue: newedit });
            }}
            resetpassword={() =>
              this.props.resetpassword(this.state.editvalue.userid)
            }
            newcontact={this.state.newcontact}
            accessStatus={this.props.accessStatus}
            employee={employee}
            reportsto={reportsTo}
            jtlist={genempdrop(this.props.employees.filter(e => e.jtadmin))}
            handlesave={emp => {
              this.handlesave(emp);
            }}
          />
        </div>
      );
    }
  }

  render() {
    var newemployee = {
      empnumber: "",
      lastname: "",
      firstname: "",
      minitial: "",
      userid: "",
      workphone: "",
      workfax: "",
      streetaddress: "",
      city: "",
      state: "",
      zipcode: "",
      homephone: "",
      emercontact: "",
      emerphonenumber: "",
      emercontact2: "",
      emerphonenumber2: "",
      homeemail: "",
      workemail: "",
      cellphonenumber: "",
      beepernumber: null,
      homefax: null,
      dob: null,
      status: "A",
      ptoexempt: 1,
      ptocarryover: 0,
      ptobalance: null,
      hiredate: null,
      termdate: null,
      rehiredate: null,
      retermdate: null,
      ptodate: null,
      reportsto: 0,
      jtadmin: 0,
      lsadmin: 0,
      hradmin: 0,
      lowcost: 0,
      emp_stat: null,
      notetoself: "",
      salarycode: 0,
      discipline: "",
      payrollcomments: ""
    };
    return (
      <div className="EmployeeInfo">
        <Grid>
          <Grid.Column width={5}>
            <Label>Select Employee to Edit</Label>

            <Dropdown
              placeholder="Employee"
              fluid
              search
              selection
              options={genempdrop(this.props.employees)}
              onChange={(e, { value }) => {
                this.setState({
                  editvalue: this.props.employees.find(
                    emp => emp.empnumber === value
                  ),
                  newcontact: false,
                  editing: true
                });
              }}
            />
          </Grid.Column>
          <Grid.Column width={2}>
            <Button
              color="blue"
              id="deletecontactbutton"
              onClick={() =>
                this.setState({
                  newcontact: true,
                  editing: true,
                  editvalue: newemployee
                })
              }
            >
              <Icon name="plus" /> Employee
            </Button>
          </Grid.Column>
          <Grid.Column width={6}>
            <Label>Select Employees to Delete</Label>
            <Dropdown
              placeholder="Employees"
              fluid
              search
              selection
              multiple
              options={genempdrop(this.props.employees)}
              onChange={(e, { value }) => {
                this.setState({ deletevalue: value });
              }}
            />
          </Grid.Column>
          <Grid.Column width={1}>
            <Button
              negative
              id="deletecontactbutton"
              onClick={() => this.handledelete()}
            >
              Delete
            </Button>
          </Grid.Column>
        </Grid>
        <Divider />

        {this.geneditform()}
      </div>
    );
  }
}
export default EmployeeInfo;



// WEBPACK FOOTER //
// ./src/components/hr/employees.jsx